import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appUpperCaseInput]'
})
export class UppercaseInputDirective {
  constructor() {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;

    const start = input.selectionStart;
    const end = input.selectionEnd;

    input.value = input.value.toUpperCase();

    if (start !== null && end !== null) {
      input.setSelectionRange(start, end);
    }
  }
}
